class SocialActivitiesTypes {

    constructor() {

         this._SEEN_ACTIVITY_TYPE = "seen";
         this._LIKE_DOCUMENT_ACTIVITY_TYPE = "like";
         this._LIKE_COMMENT_ACTIVITY_TYPE = "likeComment";
         this._FAVOURITE_ACTIVITY_TYPE = "favorite";
         this._COMPLETED_ACTIVITY_TYPE = "completed";

    }

    getTypes() {

        return {
            SEEN_ACTIVITY_TYPE: this._SEEN_ACTIVITY_TYPE,
            LIKE_DOCUMENT_ACTIVITY_TYPE: this._LIKE_DOCUMENT_ACTIVITY_TYPE,
            LIKE_COMMENT_ACTIVITY_TYPE: this._LIKE_COMMENT_ACTIVITY_TYPE,
            FAVOURITE_ACTIVITY_TYPE: this._FAVOURITE_ACTIVITY_TYPE,
            COMPLETED_ACTIVITY_TYPE: this._COMPLETED_ACTIVITY_TYPE
        }

    }

}